<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed flex-col width300 full-height" header="Optionen">
        <div class="flex-item-fixed pb-2">
            <p-button class="mr-1" icon="fas fa-run" label="Aktualisieren" (onClick)="find()">
            </p-button>
            <p-button icon="fas fa-format" label="Fehler beheben" (onClick)="fix()">
            </p-button>
        </div>
        <p-tree class="flex-item-fill full-height" [value]="warningTypesTree" selectionMode="multiple" [(selection)]="selectedWarningTypes">
        </p-tree>
    </p-panel>
    <div class="flex-item-fill flex-col">
        <p-message *ngIf="warnings?.length == 1000" class="flex-item-fixed" severity="warning" text="Es werden nicht alle Warnungen angezeigt. Menge ist auf 1000 Einträge begrenzt"></p-message>
        <p-tree *ngIf="tree != null" class="flex-item-fill height100p full-height" [value]="tree" selectionMode="checkbox" [filter]=true>
        </p-tree>
    </div>
</div>
